import { useCallback, useMemo } from 'react';
import { NavigateOptions, useNavigate } from 'react-router-dom';
import { useBatchId } from './useBatchId';

export const useExamModuleIds = () => {
	const navigate = useNavigate();
	const { navigateToRoute, queryParams } = useBatchId();

	const examId = useMemo(() => {
		const examIdParam = Number(queryParams.get('examId'));

		if (typeof examIdParam !== 'number') {
			return -1;
		}

		return examIdParam;
	}, [queryParams]);

	const navigateWithExamId = useCallback(
		(route: string, examIdParam?: number, params?: NavigateOptions) => {
			const examIdToUse = examIdParam ? `${examIdParam}` : examId;
			queryParams.set('examId', `${examIdToUse}`);
			navigateToRoute(route, params);
		},
		[examId, navigateToRoute, queryParams]
	);

	const centerId = useMemo(() => {
		const centerIdParam = Number(queryParams.get('centerId'));

		if (typeof centerIdParam !== 'number') {
			return -1;
		}

		return centerIdParam;
	}, [queryParams]);

	const navigateWithCenterId = useCallback(
		(route: string, centerIdParam?: number, params?: NavigateOptions) => {
			const centerIdToUse = centerIdParam ? `${centerIdParam}` : centerId;
			queryParams.set('centerId', `${centerIdToUse}`);
			navigateToRoute(route, params);
		},
		[centerId, navigateToRoute, queryParams]
	);

	const kanhaBatchId = useMemo(() => {
		const kanhaBatchIdParam = Number(queryParams.get('kanhaBatchId'));

		if (typeof kanhaBatchIdParam !== 'number') {
			return -1;
		}

		return kanhaBatchIdParam;
	}, [queryParams]);

	const navigateWithKanhaBatchId = useCallback(
		(route: string, kanhaBatchIdParam?: number, params?: NavigateOptions) => {
			const kanhaBatchIdToUse = kanhaBatchIdParam
				? `${kanhaBatchIdParam}`
				: kanhaBatchId;
			queryParams.set('kanhaBatchId', `${kanhaBatchIdToUse}`);
			navigateToRoute(route, params);
		},
		[kanhaBatchId, navigateToRoute, queryParams]
	);

	const getRouteWithParams = useCallback(
		(route: string) => {
			queryParams.delete('examId');
			queryParams.delete('centerId');
			queryParams.delete('kanhaBatchId');
			return `${route}?${queryParams.toString()}`;
		},
		[queryParams]
	);

	const navigateWithoutExamModuleIds = useCallback(
		(route: string, params?: NavigateOptions) => {
			navigate(`${getRouteWithParams(route)}`, params);
		},
		[getRouteWithParams, navigate]
	);

	return {
		examId,
		navigateWithExamId,
		centerId,
		navigateWithCenterId,
		kanhaBatchId,
		navigateWithKanhaBatchId,
		navigateWithoutExamModuleIds,
	};
};
